export default "__VITE_ASSET__BXAlhZae__"